import { render } from "./PasswordPageFooterCmp.vue?vue&type=template&id=26be80e2"
import script from "./PasswordPageFooterCmp.vue?vue&type=script&lang=js"
export * from "./PasswordPageFooterCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__